import { BarChartView } from './BarChart.view';
import React, { useContext } from 'react';
import { AnalyticsContext } from '../AnalyticsProvider';
import { getFillingDataConfigs, getHasFillingDataProps } from '../LineChart/LineChart.controller';
import {
  createTicksChart,
  createTicksConfigs,
  shouldHideGridLinesEveryFourLines,
  shouldHideGridLinesEverySevenLines,
  verifyWhichTicksShouldRender
} from '../helpers/chartHelpers';
import { useSettings } from '../../../hooks/useSettings';
import { StartOfWeekFormatSetting } from '../../../models/graphql';
export type BarChartConfig = {
  dataKey: string;
  fill: string;
};

export type BarChartData = {
  day: number;
  date: Date;
  timeInMs: number;
  rangeStart: Date;
  rangeEnd: Date;
} & {
  [key: string]: number | Date | undefined | null;
};
type BarChartControllerProps = {
  loading: boolean;
  activeMetrics: string[];
  chartData: BarChartData[];
  datesChart: Date[];
  firstDateFromData: string;
  lastDateFromData: string;
  maxValueAxisY: number;
};

export const BarChartController = ({
  loading,
  activeMetrics,
  chartData,
  datesChart,
  firstDateFromData,
  lastDateFromData,
  maxValueAxisY
}: BarChartControllerProps) => {
  const { selectedOrgSettings } = useSettings();
  const { startDate, endDate } = useContext(AnalyticsContext);
  const copyChartData = [...chartData];
  const dayStartOfWeek = selectedOrgSettings?.startOfWeekFormat ?? StartOfWeekFormatSetting.SUNDAY;
  const { hasPreFillingData, hasPostFillingData } = getHasFillingDataProps(startDate, endDate, dayStartOfWeek);

  const ticksConfig = createTicksConfigs(startDate, endDate);

  const tempTicks = createTicksChart(datesChart);

  const ticks = verifyWhichTicksShouldRender(
    tempTicks,
    ticksConfig,
    hasPreFillingData,
    hasPostFillingData,
    false,
    startDate,
    dayStartOfWeek
  );

  if (hasPreFillingData) {
    copyChartData.shift();
  }
  if (hasPostFillingData) {
    copyChartData.pop();
  }

  const fillingDataConfig = getFillingDataConfigs(
    firstDateFromData,
    lastDateFromData,
    startDate,
    endDate,
    0,
    maxValueAxisY,
    false,
    false,
    false,
    true,
    undefined,
    undefined
  );

  const finalChartData = copyChartData.map((a, index) => ({ ...a, fakeValue: index * 10 })); // We do that so that all bars are spread evenly
  return (
    <BarChartView
      loading={loading}
      activeMetrics={activeMetrics}
      chartData={finalChartData}
      ticksChart={ticks}
      ticksConfig={ticksConfig}
      fillingDataConfig={fillingDataConfig}
      hideGridLinesEveryFourLines={shouldHideGridLinesEveryFourLines(startDate, endDate)}
      hideGridLinesEverySevenLines={shouldHideGridLinesEverySevenLines(startDate, endDate)}
    />
  );
};
